/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Box,
  Switch,
  CardHeader,
  CardContent,
  TextField,
  InputAdornment,
  Grid,
  Link,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

import {
  AttachMoney,
  MoneyOff,
} from '@mui/icons-material';
import BillableStatusSelectComponent from '../../EnumSelects/BillableStatusSelect';
import { getColorForBillableStatus } from '../../../pages/billing/components/BillablesTable';

export const HorseBillablePriceComponent = ({
  type,
  onChange,
  eventDataDefaultValues = {},
  showHeader,
  showDescription,
  entityIdentifier,
}) => {
  const [changeBillable, setChangeBillable] = React.useState(false);

  React.useEffect(() => {
    setChangeBillable(false);
  }, [entityIdentifier])

  const eventData = useSelector((state) => state.eventData.eventData);
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);

  const getEDNameFromId = (id) => (eventData.find((ed) => ed.id === id) || { name: 'Unknown' }).name
  const value = (eventDataDefaultValues || {})[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)];
  const status = (eventDataDefaultValues || {})['Billable Status'] || 'Open';
  const receivable = (eventDataDefaultValues || {})['Billable Receivable'] || 'yes';

  const getCardContent = () => (
    <CardContent sx={{ p: '0 !important' }}>
      <Grid container alignItems="center" spacing={2}>
        <Grid
          item
          sx={{ width: 115 }}
        >
          <TextField
            id="billable-price"
            label="Amount"
            size="small"
            value={value}
            onChange={(e) => {
              if (/^[0-9]\d*(\.\d+)?$/.test(e.target.value) || e.target.value === '-' || e.target.value === '') {
                onChange({
                  ...eventDataDefaultValues,
                  [getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)]: e.target.value,
                });
              }
            }}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
              inputMode: 'numeric',
              type: 'number',
            }}
          />
        </Grid>
        <Grid item>
          <FormControl fullWidth margin="none">
            <InputLabel id="note-type-select-label">Type</InputLabel>
            <Select
              labelId="horse-access-type-select-label"
              id="horse-access-type-select"
              value={receivable || 'yes'}
              size="small"
              onChange={(e) => {
                onChange({
                  ...eventDataDefaultValues,
                  'Billable Receivable': e.target.value,
                  'Billable Status': e.target.value === 'no'
                    ? 'Expense'
                    : 'Open',
                });
              }}
              label="Type"
            >
              <MenuItem value="yes">
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <AttachMoney color="success" sx={{ mr: 1 }} />
                  <Box>Billable</Box>
                </Box>
              </MenuItem>
              <MenuItem value="no">
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <MoneyOff sx={{ mr: 1 }} />
                  <Box>Expense</Box>
                </Box>
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item sx={{ width: 150 }}>

          {
            (receivable && receivable !== 'no')
              ? (
                <BillableStatusSelectComponent
                  value={status || 'Open'}
                  size="small"
                  includeExpenseOption={false}
                  onChange={(e) => {
                    onChange({
                      ...eventDataDefaultValues,
                      'Billable Status': e.target.value,
                    });
                  }}
                />
              )
              : (
                <Box />
              )
}
        </Grid>
      </Grid>
    </CardContent>
  )

  if (type === 'inline') {
    return (
      changeBillable
        ? (
          <Box>
            {getCardContent()}
            <Link
              component="button"
              variant="body2"
              color="secondary"
              underline="hover"
              onClick={() => {
                onChange({
                  ...eventDataDefaultValues,
                  [getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)]: null,
                });
                setChangeBillable(false);
              }}
            >
              Remove Billing Transaction
            </Link>
          </Box>
        )
        : (
          <Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {
                value && (
                  <Chip
                    size="small"
                    sx={{ mr: 1 }}
                    color={getColorForBillableStatus({ status })}
                    icon={receivable === 'yes'
                      ? <AttachMoney />
                      : <MoneyOff />}
                    label={value}
                  />
                )
              }
              <Link
                component="button"
                variant="body2"
                color="secondary"
                underline="hover"
                onClick={() => {
                  setChangeBillable(true)
                  if (!value) {
                    onChange({
                      ...eventDataDefaultValues,
                      [getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)]: '0.00',
                    });
                  }
                }}
              >
                {value
                  ? 'Modify'
                  : 'Add'} Billing Transaction
              </Link>
            </Box>
          </Box>
        )
    )
  }

  return (
    <Box>
      {
        showHeader && (
          <CardHeader
            sx={{ pb: 0 }}
            title={(
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                ><AttachMoney
                  color="primary"
                  sx={{
                    mr: 1,
                    backgroundColor: 'green',
                    color: '#ffffff',
                    borderRadius: 50,
                  }}
                />Create Billing Transaction
                </Box>
                <Switch
                  checked={!!(eventDataDefaultValues && (eventDataDefaultValues[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)] || eventDataDefaultValues[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)] === ''))}
                  onChange={(e) => {
                    onChange({
                      ...eventDataDefaultValues,
                      [getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)]: e.target.checked
                        ? '0.00'
                        : null,
                    });
                  }}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              </Box>
            )}
            subheader={showDescription && 'Creates a transaction when task of this type is marked complete.'}
          />
        )
      }
      {
        (value || value === '') && (
          <Box
            sx={{
              m: showHeader
                ? 2
                : 0,
            }}
          >{ getCardContent()}
          </Box>

        )
      }
    </Box>
  );
}

HorseBillablePriceComponent.propTypes = {
  onChange: PropTypes.func,
  eventDataDefaultValues: PropTypes.object,
  type: PropTypes.string,
  showHeader: PropTypes.bool,
  showDescription: PropTypes.bool,
  entityIdentifier: PropTypes.any, // used to trigger when the resource changes and we need to reset form
};

HorseBillablePriceComponent.defaultProps = {
  onChange: () => {},
  eventDataDefaultValues: null,
  type: 'card',
  showHeader: false,
  showDescription: false,
  entityIdentifier: '',
};

export default HorseBillablePriceComponent;
